<template>
  <div class="NeighborhoodStateAdvertisementadd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump">{{$t('lang.lab_NeighBack')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon" class="form">
        <el-form-item :label="$t('lang.lab_community')" prop="gardenId">
          <el-select v-if="this.id" class="single-select" v-model="ruleForm.gardenId"
            :placeholder="$t('lang.lab_selectCommunity')" collapse-tags>
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-else class="multiple-select" v-model="ruleForm.gardenIds"
            :placeholder="$t('lang.lab_selectCommunity')" collapse-tags multiple filterable clearable @change="change">
            <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverTitle')" prop="name">
          <el-input maxlength="20" style="width:30%" class="select" v-model="ruleForm.name"
            :placeholder="$t('lang.lab_AllRemitTitle')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverSort')" prop="orderBy">
          <el-input-number :placeholder="$t('lang.lab_AdverSortText')" class="select"
            :label="$t('lang.lab_AdverSortText')" v-model="ruleForm.orderBy" controls-position="right"
            @change="handleChange" :min="1" :max="99"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverType')" prop="type">
          <el-select v-model="ruleForm.type" placeholder>
            <el-option v-for="item in NeighType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverStatus')" prop="state">
          <el-select v-model="ruleForm.state" placeholder>
            <el-option v-for="item in NeighStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverBeginDate')" prop="beginTs">
          <div>
            <el-date-picker v-model="ruleForm.beginTs" type="date" value-format="timestamp"
              :placeholder="$t('lang.selecttimes')"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverEndDate')" prop="endTs">
          <div>
            <el-date-picker v-model="ruleForm.endTs" type="date" value-format="timestamp"
              :placeholder="$t('lang.selecttimes')"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverGoUrl')">
          <el-input style="width:50%" class="select" v-model="ruleForm.targetUri"
            :placeholder="$t('lang.lab_AdverWriteUrl')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="imageUri" ref="imageUri">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="fileList" :clears="clears"
            @outputFile="getFile" @removeFile="removeFile"></upload-file>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isCanUse" @click="onSubmit('ruleForm')">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:NeighborhoodStateAdvertisementadd
   *@Description:邻里帮广告管理添加编辑
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-04-08
   */
  import UploadFile from '../../../components/upload_file.vue'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      // eslint-disable-next-line
      var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
        } else if (value.length > 512) {
          callback(new Error(this.$i18n.t('lang.lab_BigLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
      }
      return {
        clears: false, // 清空按钮
        accept: '.jpg, .jpeg, .png',
        fileList: [], // 文件列表
        isCanUse: true, // 保存按钮可用状态
        changeIt: '', // 添加是1   编辑是0
        id: '', // 广告id
        rules: {
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_AllRemitTitle'),
            trigger: 'blur'
          }],
          orderBy: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverPleaseSort'),
            trigger: 'blur'
          }],
          locationName: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverPleaseWriteUrlName'),
            trigger: 'blur'
          }],
          targetUri: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          imageUri: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          beginTs: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverSelectBeginDate'),
            trigger: 'change'
          }],
          endTs: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverSelsetEndDate'),
            trigger: 'change'
          }]
        },
        editorOption: {
          // 富文本的类型
          theme: 'snow'
        },
        tableData: [],
        ruleForm: {
          gardenId: 0,
          gardenIds: [],
          state: 1, // 广告状态
          targetUri: '', // 跳转链接
          name: '', // 名称
          imageUri: '', // 图片链接
          fileList: [], // 上传文件集合
          type: 304, // 广告类型
          beginTs: Date.parse(new Date()), // 开始时间
          endTs: Date.parse(new Date()), // 结束时间
          orderBy: '1' // 排序方式
        },
        oldsearchUnit: [],
        // gardens: [], // 小区集合
        garden: [], // 所选小区
        options: this.$i18n.t('lang.options'),
        detail: this.$i18n.t('lang.ownerApp'),
        NeighStatus: this.$i18n.t('lang.NeighSelect.NeighStatus'), // 广告状态下拉列表
        NeighType: this.$i18n.t('lang.NeighSelect.NeighType') // 广告类型下拉列表
      }
    },
    components: {
      'upload-file': UploadFile
    },
    destroyed() {
      window.localStorage.setItem('llbform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('llbsaveData', JSON.stringify(this.saveData))
    },
    created() {
      // 获取广告id 有id是编辑  没有id是添加
      this.id = this.$route.query.id
      if (window.localStorage.getItem('llbform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('llbform'))
        if (this.ruleForm.imageUri) {
          this.fileList.push({
            name: '',
            url: this.ruleForm.imageUri
          })
        }
        if (window.localStorage.getItem('llbsaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('llbsaveData'))
        }
      } else {
        if (this.id) {
          this.myGarden()
          this.ads()                  
          this.changeIt = 0
        } else {
          // 添加
          this.changeIt = 1
          // this.selectGarden()
        }
      }
    },
    computed: {
      ...mapGetters({
        gardens: 'userGardenList'
      })
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          console.log(tempRule === this.saveData)
          if (tempRule == this.saveData) {
            // 没变
            this.isCanUse = true
          } else {
            // 变了
            this.isCanUse = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      ads() {
        let loading = this.$loading()
        this.$get(`/ads/${this.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              res.gardenId = res.gardenid
              this.ruleForm = res
              if (this.ruleForm.imageUri) {
                this.fileList.push({
                  name: '',
                  url: this.ruleForm.imageUri
                })
              } else {
                this.fileList = []
                this.ruleForm.imageUri = ''
              }
              this.saveData = JSON.stringify(this.ruleForm)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 小区下拉
      myGarden() {
        let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.garden = myGardens
      },
      // 小区下拉
      // selectGarden() {
      //   this.$get(`/gardens`).then(
      //     res => {
      //       if (res && res.errCode === 0) {
      //         this.gardens = res.list
      //       }
      //     },
      //     error => {
      //       this.$message.error(error)
      //     }
      //   )
      // },
      // 多选项
      change(val) {
        const allValues = []
        // 将全选"0"加入allValues
        allValues.push(0)
        for (const item of this.gardens) {
          allValues.push(item.id)
        }
        // 用来储存上一次选择的值，可进行对比
        const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
        // 若选择全部
        if (val.includes(0)) {
          this.ruleForm.gardenIds = allValues
        }
        // 取消全部选中， 上次有， 当前没有， 表示取消全选
        if (oldVal.includes(0) && !val.includes(0)) {
          this.ruleForm.gardenIds = []
        }
        // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
        if (oldVal.includes(0) && val.includes(0)) {
          const index = val.indexOf(0)
          val.splice(index, 1)
          this.ruleForm.gardenIds = val
        }
        // 全选未选，但是其他选项都全部选上了，则全选选上
        if (!oldVal.includes(0) && !val.includes(0)) {
          if (val.length === allValues.length - 1) {
            this.ruleForm.gardenIds = [0].concat(val)
          }
        }
        // 储存当前选择的最后结果 作为下次的老数据
        this.oldsearchUnit[0] = this.ruleForm.gardenIds
      },
      // 获取组件值
      getFile(e) {
        this.ruleForm.imageUri = e
        this.$refs.imageUri.clearValidate()
      },
      // 移除图片
      removeFile(e) {
        this.fileList = []
        this.ruleForm.imageUri = ''
      },
      handleChange(value) {
        console.log(value)
      },
      // 返回邻里帮广告列表
      jump() {
        this.$router.push({
          name: 'NeighborhoodStateAdvertisementList'
        })
      },
      // 保存方法
      onSubmit(formName) {
        if (this.ruleForm.endTs < this.ruleForm.beginTs) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_AdverTimeTips')
          })
          return
        }
        // 添加
        if (this.changeIt == 1) {
          let params = {
            'garden[]': this.ruleForm.gardenIds.toString(),
            name: this.ruleForm.name,
            orderBy: this.ruleForm.orderBy,
            type: this.ruleForm.type,
            state: this.ruleForm.state,
            beginTs: this.ruleForm.beginTs,
            endTs: this.ruleForm.endTs,
            imageUri: this.ruleForm.imageUri,
            targetUri: this.ruleForm.targetUri
          }
          console.log(params)
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$post('/ads', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.eagleEye.addSucceed')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.pivot3')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'NeighborhoodStateAdvertisementList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        } else if (this.changeIt == 0) {
          // 编辑
          let params = {
            shareFlag: this.ruleForm.gardenId,
            name: this.ruleForm.name,
            orderBy: this.ruleForm.orderBy.toString(),
            type: this.ruleForm.type,
            state: this.ruleForm.state,
            beginTs: this.ruleForm.beginTs,
            endTs: this.ruleForm.endTs,
            imageUri: this.ruleForm.imageUri,
            targetUri: this.ruleForm.targetUri
          }
          console.log(params)
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$patch(`/ads/${this.id}`, params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modify_success')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.pivot3')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'NeighborhoodStateAdvertisementList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        }
      },
      // 清空方法
      resetForm(formName) {
        this.fileList = []
        this.clears = true
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.name = ''
        this.ruleForm.orderBy = '1'
        this.ruleForm.type = 304
        this.ruleForm.state = 1
        this.ruleForm.beginTs = Date.parse(new Date())
        this.ruleForm.endTs = Date.parse(new Date())
        this.fileList = []
        this.ruleForm.fileList = []
        this.ruleForm.imageUri = ''
        this.ruleForm.targetUri = ''
        this.ruleForm.gardenId = ''
        this.$refs.uploading.clearFiles()
      }
    }
  }
</script>

<style lang="scss">
</style>